import { Desktop, Mobile } from '../../Common/const';

function SubmitAQuestionHeader() {
  return (
    <div>
      <Desktop>
        <div className="resources-header-container pt-5 pl-4 pb-5">
          Submit A Question
        </div>
        <div className="gradient-divider" />
      </Desktop>
      <Mobile>
        <div className="gradient-divider" />
      </Mobile>
    </div>
  );
}

export default SubmitAQuestionHeader;
